import { render, staticRenderFns } from "./TextImageFlex.vue?vue&type=template&id=12c3fe8a&scoped=true"
import script from "./TextImageFlex.vue?vue&type=script&lang=js"
export * from "./TextImageFlex.vue?vue&type=script&lang=js"
import style0 from "./TextImageFlex.vue?vue&type=style&index=0&id=12c3fe8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3fe8a",
  null
  
)

export default component.exports